// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import logo from "../assets/Logo.webp"

// export default function Navbar() {
//   const [scrolled, setScrolled] = useState(false);
//   const [open, setOpen] = useState(false);

//   useEffect(() => {
//     const onScroll = () => setScrolled(window.scrollY > 10);
//     window.addEventListener("scroll", onScroll);
//     return () => window.removeEventListener("scroll", onScroll);
//   }, []);

//   return (
//     <header
//       className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
//         scrolled ? "backdrop-blur-lg bg-white/20 shadow-lg" : "bg-transparent"
//       }`}
//     >
//       <div className="max-w-7xl mx-auto flex items-center justify-between py-3 px-4 md:px-8">
//         {/* Logo */}
//         <Link to="/" className="flex items-center gap-2">
//           <img
//             src={logo}
//             alt="PixlyBooth"
//             className="h-16 w-auto drop-shadow-lg"
//           />
//         </Link>

//         {/* Desktop nav */}
//         <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-100">
//           <a href="/" className="hover:text-[#E34364] transition">
//             Home
//           </a>
//           <a href="/" className="hover:text-[#E34364] transition">
//             About Us
//           </a>
//           <a href="/" className="hover:text-[#E34364] transition">
//             Our Services
//           </a>
//           <a href="/" className="hover:text-[#E34364] transition">
//             Backdrops
//           </a>
//           <a href="/" className="hover:text-[#E34364] transition">
//             Gallery
//           </a>
//           <a href="/" className="hover:text-[#E34364] transition">
//             Reviews
//           </a>
//         </nav>

//         {/* CTA */}
//         <a
//           href="#contact"
//           className="hidden md:inline-flex items-center gap-2 bg-[#E34364] text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg shadow-[#E34364]/40 hover:shadow-[#E34364]/60 hover:-translate-y-[1px] transition"
//         >
//           Book Now
//         </a>

//         {/* Mobile hamburger */}
//         <button
//           className="md:hidden text-white"
//           onClick={() => setOpen((o) => !o)}
//         >
//           <span className="sr-only">Toggle menu</span>
//           <div className="space-y-1">
//             <span
//               className={`block h-[2px] w-5 bg-white transition ${
//                 open ? "translate-y-[5px] rotate-45" : ""
//               }`}
//             />
//             <span
//               className={`block h-[2px] w-4 bg-white transition ${
//                 open ? "opacity-0" : ""
//               }`}
//             />
//             <span
//               className={`block h-[2px] w-5 bg-white transition ${
//                 open ? "-translate-y-[5px] -rotate-45" : ""
//               }`}
//             />
//           </div>
//         </button>
//       </div>

//       {/* Mobile dropdown */}
//       {open && (
//         <div className="md:hidden bg-black/90 backdrop-blur-lg border-t border-white/10">
//           <nav className="px-4 py-3 flex flex-col gap-3 text-sm text-white">
//             <a href="#about" onClick={() => setOpen(false)}>
//               About
//             </a>
//             <a href="#services" onClick={() => setOpen(false)}>
//               Services
//             </a>
//             <a href="#backdrops" onClick={() => setOpen(false)}>
//               Backdrops
//             </a>
//             <a href="#gallery" onClick={() => setOpen(false)}>
//               Gallery
//             </a>
//             <a href="#testimonials" onClick={() => setOpen(false)}>
//               Reviews
//             </a>
//             <a
//               href="#contact"
//               onClick={() => setOpen(false)}
//               className="mt-2 inline-flex justify-center bg-[#E34364] text-white px-4 py-2 rounded-full"
//             >
//               Book Now
//             </a>
//           </nav>
//         </div>
//       )}
//     </header>
import React, { useEffect, useState, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/Logo.webp";
import { useAuth } from "../context/AuthContext";
import { useSocket } from "../context/SocketContext";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "https://api.pixlybooth.com";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [unread, setUnread] = useState(0);

  const { user, logout } = useAuth();
  const { socket } = useSocket();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Fetch unread count for authenticated users
  useEffect(() => {
    if (!user) { setUnread(0); return; }
    axios.get(`${API}/api/notifications`, { withCredentials: true })
      .then(r => setUnread(r.data.unreadCount || 0)).catch(() => {});
  }, [user]);

  // Real-time notification badge
  useEffect(() => {
    if (!socket) return;
    const inc = () => setUnread(n => n + 1);
    socket.on("status_update", inc);
    socket.on("contract_ready", inc);
    return () => { socket.off("status_update", inc); socket.off("contract_ready", inc); };
  }, [socket]);

  const handleLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };

  const goToSection = useCallback(
    (id) => (e) => {
      e.preventDefault();
      setOpen(false);
      const scrollNow = () => {
        requestAnimationFrame(() => {
          const el = document.getElementById(id);
          if (!el) return;
          const y = el.getBoundingClientRect().top + window.scrollY - 90;
          window.scrollTo({ top: y, behavior: "smooth" });
        });
      };
      if (location.pathname !== "/") {
        navigate("/", { replace: false });
        setTimeout(scrollNow, 50);
      } else {
        scrollNow();
      }
    },
    [location.pathname, navigate]
  );

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-lg bg-white/20 shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between py-3 px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2" onClick={() => setOpen(false)}>
          <img src={logo} alt="PixlyBooth" className="h-16 w-auto drop-shadow-lg" />
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-100">
          <a href="#home" onClick={goToSection("home")} className="hover:text-[#E34364] transition">Home</a>
          <a href="#about" onClick={goToSection("about")} className="hover:text-[#E34364] transition">About Us</a>
          <a href="#services" onClick={goToSection("services")} className="hover:text-[#E34364] transition">Our Services</a>
          <Link to="/backdrops" className="hover:text-[#E34364] transition">Backdrops</Link>
          <a href="#gallery" onClick={goToSection("gallery")} className="hover:text-[#E34364] transition">Gallery</a>
          <a href="#reviews" onClick={goToSection("testimonials")} className="hover:text-[#E34364] transition">Reviews</a>
          {/* <Link to="/contact" className="hover:text-[#E34364] transition">Contact Us</Link> */}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              {/* Notification bell */}
              <Link to="/dashboard/notifications" style={{ position: "relative", color: "#fff", textDecoration: "none", fontSize: 18 }}>
                🔔
                {unread > 0 && (
                  <span style={{ position: "absolute", top: -6, right: -6, background: "#E34364", color: "#fff", fontSize: 9, fontWeight: 700, width: 16, height: 16, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {unread > 9 ? "9+" : unread}
                  </span>
                )}
              </Link>

              {/* User avatar dropdown */}
              <div style={{ position: "relative" }}>
                <button
                  onClick={() => setUserMenuOpen(o => !o)}
                  style={{ width: 36, height: 36, borderRadius: "50%", background: "#E34364", color: "#fff", border: "none", fontWeight: 700, fontSize: 14, cursor: "pointer" }}
                >
                  {user.name?.[0]?.toUpperCase()}
                </button>
                {userMenuOpen && (
                  <div style={{ position: "absolute", right: 0, top: 44, background: "#101428", border: "1px solid rgba(227,67,100,0.3)", borderRadius: 12, padding: "8px 0", minWidth: 160, zIndex: 200, boxShadow: "0 8px 32px rgba(0,0,0,0.5)" }}>
                    <p style={{ margin: 0, padding: "8px 16px 4px", fontSize: 12, color: "#a0a0b8" }}>{user.email}</p>
                    <Link to={user.role === "admin" ? "/admin" : "/dashboard"} onClick={() => setUserMenuOpen(false)} style={{ display: "block", padding: "10px 16px", color: "#fff", textDecoration: "none", fontSize: 13 }}>
                      {user.role === "admin" ? "🛠 Admin Panel" : "📋 My Dashboard"}
                    </Link>
                    <button onClick={() => { setUserMenuOpen(false); handleLogout(); }} style={{ width: "100%", textAlign: "left", padding: "10px 16px", background: "none", border: "none", color: "#E34364", fontSize: 13, cursor: "pointer" }}>
                      🚪 Sign Out
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm text-gray-300 hover:text-white transition">Sign In</Link>
              <Link to="/book" className="inline-flex items-center gap-2 bg-[#E34364] text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg shadow-[#E34364]/40 hover:shadow-[#E34364]/60 hover:-translate-y-[1px] transition">
                Book Now
              </Link>
            </>
          )}
        </div>

        <button className="md:hidden text-white" onClick={() => setOpen((o) => !o)}>
          <span className="sr-only">Toggle menu</span>
          <div className="space-y-1">
            <span className={`block h-[2px] w-5 bg-white transition ${open ? "translate-y-[5px] rotate-45" : ""}`} />
            <span className={`block h-[2px] w-4 bg-white transition ${open ? "opacity-0" : ""}`} />
            <span className={`block h-[2px] w-5 bg-white transition ${open ? "-translate-y-[5px] -rotate-45" : ""}`} />
          </div>
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black/90 backdrop-blur-lg border-t border-white/10">
          <nav className="px-4 py-3 flex flex-col gap-3 text-sm text-white">
            <a href="#home" onClick={goToSection("home")}>Home</a>
            <a href="#about" onClick={goToSection("about")}>About Us</a>
            <a href="#services" onClick={goToSection("services")}>Our Services</a>
            <Link to="/backdrops" onClick={() => setOpen(false)}>Backdrops</Link>
            <a href="#gallery" onClick={goToSection("gallery")}>Gallery</a>
            <a href="#reviews" onClick={goToSection("testimonials")}>Reviews</a>
            <Link to="/contact" onClick={() => setOpen(false)}>Contact Us</Link>
            {user ? (
              <>
                <Link to={user.role === "admin" ? "/admin" : "/dashboard"} onClick={() => setOpen(false)} className="mt-2">
                  {user.role === "admin" ? "🛠 Admin Panel" : "📋 My Dashboard"}
                </Link>
                <button onClick={() => { setOpen(false); handleLogout(); }} style={{ background: "none", border: "none", color: "#E34364", textAlign: "left", fontSize: 14, cursor: "pointer", padding: 0 }}>
                  🚪 Sign Out
                </button>
              </>
            ) : (
              <Link to="/book" onClick={() => setOpen(false)} className="mt-2 inline-flex justify-center bg-[#E34364] text-white px-4 py-2 rounded-full">
                Book Now
              </Link>
            )}
          </nav>
        </div>
      )}
    </header>
  );
}
